import React, { useEffect, useState, useRef, useCallback} from "react";
import Select from "react-select";
import './26asreports.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from 'ag-grid-react';
import { getvendorcode, getBalanceFromServer,updatedonutvalue,Fetchupdatequery ,updateclosurestatusvalue,Fetcherpdata_1,Fetchexecutequery,Fetchbankdata_1,Fetchbankinvoicedetails1,Fetchbankdata,Fetchexternaldetails, getProcessingLayerDataFromServer, getProcessingLayerDataWithStatusFromServer, getUpdateMatchRecordsFromServer, getUpdateUnMatchRecordsFromServer, getUpdateDuplicateRecordsFromServer, getUpdateContraRecordsFromServer, getProcessingLayerDataReturnFromServer, getUpdateGlBalFromServer, getUpdateBankBalFromServer, Fetchbankinvoicedetails,Fetcherpdata, Fetchmatchedutrdata, Fetchmatchedutrdata1, updatestatusvalue, allocateupdatestatusvalue, fetchmonthwisedata1, getdonutseriesdata, getkpidatarecon, getpaymenthistory, getstatustypeslist, getremarksdata, fetchmonthwisedatanew, getpaymenthistorynew, getdataforcardsrecon } from '../../../services/process/BRS1/brsService1';
import LoaderComponent from "../../../libraries/loader/loader";
import { saveJsonfileToServer, port, getFileProcessFromServer1, getFileProcessFromServer2 } from '../../../services/process/medical-insurance/medicalInsuranceReportService';
import axios from "axios";
import excelIcon from '../../../assets/images/excel.png';
import * as XLSX from 'xlsx';
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Menu, Form, TextArea, Label } from 'semantic-ui-react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { baseUrl } from "../../../services/common/credentials";


var aggCallCount = 0;

var compareCallCount = 0;

var filterCallCount = 0;

const localhost_url = baseUrl + port;


function AlcsReport() {
    const [inputMonth, setInputMonth] = useState(undefined);
    const [extGridData, setExtGridData] = useState([]);
    const [hideResultGrid, setHideResultGrid] = useState(true);
    const [loaderOpen, setLoaderOpen] = useState(false);
    const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
    const [rowData, setRowData] = useState([]);
    const [paginationSize] = useState(15);
    const [datacolumnnames, setdatacolumnnames] = useState([]);
    const [companyname, setCompanyName] = useState({});
    const [type, setType] = useState(undefined);
    const [type2, setType2] = useState(undefined);
    const [gridColumns, setGridColumns] = useState([]);
    const gridRef = useRef();
    const [isutr, isSetUtr] = useState(false);
    const [columnnames, setColumnNames] = useState([]);
    const [columnnames1, setColumnNames1] = useState([]);   
    const [fromyears, setFromyear] = useState('');
    const [toyears, setToyear] = useState('');
 

    var utr_columns = [
       
        { field: 'Bank Name', headerName: 'Bank Name', sortable: true, filter: true, resizable: true, editable: true },
        { field: 'Account No', headerName: 'Account No', sortable: true, filter: true, resizable: true },
        { field: 'Accpac Code', headerName: 'Accpac Code', sortable: true, filter: true, resizable: true },
        { field: 'Date', headerName: 'Date', sortable: true, filter: true, resizable: true },
        { field: 'Acc', headerName: 'Acc', sortable: true, filter: true, resizable: true },
        { field: 'Issued_Amt', headerName: 'Issued_Amt', sortable: true, filter: true, resizable: true },
        { field: 'Name', headerName: 'Name', sortable: true, filter: true, resizable: true },
        { field: 'Company', headerName: 'Company', sortable: true, filter: true, resizable: true },
        { field: 'Emp#', headerName: 'Emp#', sortable: true, filter: true, resizable: true },       
        { field: 'Client Id', headerName: 'Client Id', sortable: true, filter: true, resizable: true },
        { field: 'Remarks', headerName: 'Remarks', sortable: true, filter: true, resizable: true },
        { field: 'invoice no', headerName: 'invoice no', sortable: true, filter: true, resizable: true },
        { field: 'IFSC CODES', headerName: 'IFSC CODES', sortable: true, filter: true, resizable: true },
        { field: 'Letter upload No', headerName: 'Letter upload No', sortable: true, filter: true, resizable: true },
        { field: 'PM_Payment_Date', headerName: 'PM_Payment_Date', sortable: true, filter: true, resizable: true },
        { field: 'UTR Number', headerName: 'UTR Number', sortable: true, filter: true, resizable: true },
        { field: 'Debit Date', headerName: 'Debit Date', sortable: true, filter: true, resizable: true },
        { field: 'Payment_Id', headerName: 'Payment_Id', sortable: true, filter: true, resizable: true },
        { field: 'BatchID', headerName: 'BatchID', sortable: true, filter: true, resizable: true },
        { field: 'Advice Squence', headerName: 'Advice Squence', sortable: true, filter: true, resizable: true },
        
    ];


    var utr_columns1 = [
        { field: '', headerCheckboxSelection: true, checkboxSelection: true, showDisabledCheckboxes: true, width:50},
        { field: 'Bank Name', headerName: 'Bank Name', sortable: true, filter: true, resizable: true},
        { field: 'Account No', headerName: 'Account No', sortable: true, filter: true, resizable: true },
        { field: 'Accpac Code', headerName: 'Accpac Code', sortable: true, filter: true, resizable: true },
        { field: 'Date', headerName: 'Date', sortable: true, filter: true, resizable: true },
        { field: 'Acc', headerName: 'Acc', sortable: true, filter: true, resizable: true },
        { field: 'Issued_Amt', headerName: 'Issued_Amt', sortable: true, filter: true, resizable: true },
        { field: 'Name', headerName: 'Name', sortable: true, filter: true, resizable: true },
        { field: 'Company', headerName: 'Company', sortable: true, filter: true, resizable: true },
        { field: 'Emp#', headerName: 'Emp#', sortable: true, filter: true, resizable: true },       
        { field: 'Client Id', headerName: 'Client Id', sortable: true, filter: true, resizable: true },
        { field: 'Remarks', headerName: 'Remarks', sortable: true, filter: true, resizable: true },
        { field: 'invoice no', headerName: 'invoice no', sortable: true, filter: true, resizable: true },
        { field: 'IFSC CODES', headerName: 'IFSC CODES', sortable: true, filter: true, resizable: true },
        { field: 'Letter upload No', headerName: 'Letter upload No', sortable: true, filter: true, resizable: true },
        { field: 'PM_Payment_Date', headerName: 'PM_Payment_Date', sortable: true, filter: true, resizable: true },
        { field: 'UTR Number', headerName: 'UTR Number', sortable: true, filter: true, resizable: true, editable: true  },
        { field: 'Debit Date', headerName: 'Debit Date', sortable: true, filter: true, resizable: true, editable: true },
        { field: 'Payment_Id', headerName: 'Payment_Id', sortable: true, filter: true, resizable: true },
        { field: 'BatchID', headerName: 'BatchID', sortable: true, filter: true, resizable: true },
        { field: 'Advice Squence', headerName: 'Advice Squence', sortable: true, filter: true, resizable: true },
    ];


    var advice_columns = [
        { field: 'advice column', headerName: 'advice column', sortable: true, filter: true, resizable: true },
        { field: 'total', headerName: 'total', sortable: true, filter: true, resizable: true },
        { field: 'Withdrawed Amount', headerName: 'Withdrawed Amount', sortable: true, filter: true, resizable: true },
        { field: 'debit date', headerName: 'debit date', sortable: true, filter: true, resizable: true },
		{ field: 'Transaction Details', headerName: 'Transaction Details', sortable: true, filter: true, resizable: true }
    ]
 


    useEffect(() => {
	BrsTypeList();
	BrsTypeList1();
    }, []);


const Fetchinfo = () => {
    let payload;
    setLoaderOpen(true);

    if (type2.value === 'TAN Report') {
        payload = {
            query: `SELECT
    e.form_26as_tan,
    e.form_26as_customer_name,
    COALESCE(SUM(e.form_26as_debit), 0) AS 'TDS Deposited',
    i.erp_tan AS 'ERP TAN',
    i.erp_customer_name AS 'Customer Name',
    COALESCE(SUM(i.erp_debit), 0) AS 'ERP Amount',
    ROUND(COALESCE(SUM(i.erp_debit), 0) - COALESCE(SUM(e.form_26as_debit), 0), 2) AS Difference
FROM (
    SELECT
        \`TAN of Deductor\` AS form_26as_tan,
        \`Name of Deductor\` AS form_26as_customer_name,
        CONVERT(SUM(IFNULL(\`Total TDS Deposited(Rs.)\`, 0)), CHAR) AS form_26as_debit
    FROM tds.form_26as
    WHERE \`TAN of Deductor\` IS NOT NULL
        AND from_period = '${fromyears}' AND to_period = '${toyears}'
    GROUP BY \`TAN of Deductor\`
) AS e
LEFT JOIN (
    SELECT
        tan AS erp_tan,
        customer_name AS erp_customer_name,
        CONVERT(SUM(IFNULL(Debits, 0)) - SUM(IFNULL(Credits, 0)), CHAR) AS erp_debit
    FROM tds.accpac
    WHERE tan IS NOT NULL
        AND customer_name IS NOT NULL
        AND from_period = '${fromyears}' AND to_period = '${toyears}'
    GROUP BY tan
) AS i ON e.form_26as_tan = i.erp_tan
GROUP BY e.form_26as_tan, i.erp_tan

UNION ALL

SELECT
    NULL AS form_26as_tan,
    NULL AS form_26as_customer_name,
    0 AS \`TDS Deposited\`,
    acc.tan AS \`ERP TAN\`,
    acc.customer_name AS \`Customer Name\`,
    CONVERT(SUM(IFNULL(acc.Debits, 0)) - SUM(IFNULL(acc.Credits, 0)), CHAR) AS \`ERP Amount\`,
    ROUND(COALESCE(SUM(IFNULL(acc.Debits, 0)), 0) - COALESCE(SUM(IFNULL(acc.Credits, 0)), 0), 2) AS Difference
FROM tds.accpac acc
WHERE acc.tan IS NOT NULL
    AND acc.customer_name IS NOT NULL
    AND acc.from_period = '${fromyears}' AND acc.to_period = '${toyears}'
    AND acc.tan NOT IN (
        SELECT \`TAN of Deductor\`
        FROM tds.form_26as
        WHERE \`TAN of Deductor\` IS NOT NULL
            AND from_period = '${fromyears}' AND to_period = '${toyears}'
    )
GROUP BY acc.tan, acc.customer_name;`
        };
    } else if (type2.value === 'NAD Report') {
        payload = {
            query: `SELECT
    e.form_26as_nad,
    e.form_26as_customer_name,
    COALESCE(SUM(e.form_26as_debit), 0) AS 'TDS Deposited',
    i.erp_nad AS 'ERP NAD',
    i.erp_customer_name AS 'Customer Name',
    COALESCE(SUM(i.erp_debit), 0) AS 'ERP Amount',
    ROUND(COALESCE(SUM(i.erp_debit), 0) - COALESCE(SUM(e.form_26as_debit), 0), 2) AS Difference
FROM (
    SELECT
        nad AS form_26as_nad,
        \`Name of Deductor\` AS form_26as_customer_name,
        CONVERT(SUM(IFNULL(\`Total TDS Deposited(Rs.)\`, 0)), CHAR) AS form_26as_debit
    	FROM tds.form_26as
    	WHERE \`nad\` IS NOT NULL
        AND \`Name of Deductor\` IS NOT NULL
        AND from_period = '${fromyears}' AND to_period = '${toyears}'
 	GROUP BY \`nad\`, \`Name of Deductor\`
	) AS e
	LEFT JOIN (
    	SELECT
        nad AS erp_nad,
        customer_name AS erp_customer_name,
        CONVERT(SUM(IFNULL(Debits, 0)) - SUM(IFNULL(Credits, 0)), CHAR) AS erp_debit
    	FROM tds.accpac
    	WHERE nad IS NOT NULL
        AND customer_name IS NOT NULL
        AND from_period = '${fromyears}' AND to_period = '${toyears}'
   	 GROUP BY nad
	) AS i ON e.form_26as_nad = i.erp_nad
	GROUP BY e.form_26as_nad, i.erp_nad


UNION ALL

SELECT
    NULL AS form_26as_nad,
    NULL AS form_26as_customer_name,
    0 AS \`TDS Deposited\`,
    acc.nad AS \`ERP NAD\`,
    acc.customer_name AS \`Customer Name\`,
    CONVERT(SUM(IFNULL(acc.Debits, 0)) - SUM(IFNULL(acc.Credits, 0)), CHAR) AS \`ERP Amount\`,
    ROUND(COALESCE(SUM(IFNULL(acc.Debits, 0)), 0) - COALESCE(SUM(IFNULL(acc.Credits, 0)), 0), 2) AS Difference
FROM tds.accpac acc
WHERE acc.nad IS NOT NULL
    AND acc.customer_name IS NOT NULL
    AND acc.from_period = '${fromyears}' AND acc.to_period = '${toyears}'
    AND acc.nad NOT IN (
        SELECT \`nad\`
        FROM tds.form_26as
        WHERE \`nad\` IS NOT NULL
            AND from_period = '${fromyears}' AND to_period = '${toyears}'
    )
GROUP BY acc.tan, acc.customer_name;`
        };
    	} else if  (type2.value === 'ERP Without TAN Report'){
        payload = {
            query: `select * FROM tds.accpac where tan is null;`
        };

	} else if  (type2.value === 'Form26as Without NAD Report'){
        payload = {
            query: `select * FROM tds.form_26as where nad is null;`
        };

	} else if  (type2.value === 'Customer Master with TAN'){
        payload = {
            query: `select * FROM tds.customer_master where TAN is not null;`
        };

	} else if  (type2.value === 'Customer Master without TAN'){
        payload = {
            query: `select * FROM tds.customer_master where TAN is null;`
        };

	}else {
        payload = {
            query: `select * from BRS.axis_18294_bank_statement where primary_id =1;`
        };
    }

    console.log('payload---', payload, type, type2);

    const FileUploadCredentials = Fetchexecutequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          let data = response["data"];
          setExtGridData(data);
          setHideResultGrid(false);
          setLoaderOpen(false);
        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }

  const intColumnDefs10 = React.useMemo(() => {
    if (extGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(extGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 130,
        })),
      ];
      setdatacolumnnames(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [extGridData]);


const generateFinancialYearOptions = (startYear, numYears) => {
  const optionsyr = [];
  for (let i = 0; i < numYears; i++) {
    const year1 = startYear + i;
    const year2 = year1 + 1;
    const financialYear = `${year1}-${year2}`;
    optionsyr.push({ key: financialYear, value: financialYear, label: financialYear });
  }
  return optionsyr;
};


  function BrsTypeList() {
    setLoaderOpen(true);
    const startYear = 2020;
    const numYears = 20; // For example, generate 10 years of options

    const financialYearOptions = generateFinancialYearOptions(startYear, numYears);

    setColumnNames(financialYearOptions);
    // setclientids(client_ids);    
    setLoaderOpen(false);
  }

  function BrsTypeList1() {
    let reportoptions = [{ label: 'TAN Report', value: 'TAN Report'},{ label: 'NAD Report', value: 'NAD Report'},{ label: 'ERP Without TAN Report', value: 'ERP Without TAN Report'},{ label: 'Form26as Without NAD Report', value: 'Form26as Without NAD Report'},{ label: 'Customer Master with TAN', value: 'Customer Master with TAN' },{ label: 'Customer Master without TAN', value: 'Customer Master without TAN' }];
    setColumnNames1(reportoptions);
        
  }

	
	const intColumnDefs = React.useMemo(() => {
        if (rowData?.length > 0) {
          // Get the column names from the first row of the JSON data
          const keys = Object.keys(rowData[0]);
      
          // Create column definitions with the checkbox as the first column
          const intColumnDefs = [
            
            ...keys.map((key) => ({
              headerName: key,
              field: key,
              sortable: true, 
              filter: true, 
              resizable: true
            })),
          ];
          setGridColumns(intColumnDefs);
          console.log('intColumnDefs', intColumnDefs);
          return intColumnDefs;
        }
        return [];
      }, [rowData]);

    const makeAPICall = async (url) => {
        try {
            setLoaderOpen(true);
            console.log(url);
            const response = await fetch(url);
            const data = await response.json();
            setRowData(data);
           console.log('data', data);
            setHideResultGrid(false);
            setLoaderOpen(false);
        }
        catch (e) {
            console.log(e);
            setLoaderOpen(false);
            setHideResultGrid(true);
        }
    }
  
    

    const customStyles = {
        control: base => ({
            ...base,
            height: 35,
            minHeight: 35,
            marginTop: 0,
            paddingTop: 0,
            fontSize: 14,
            width: '100%'
            
        })
    };


    function searchClick(event) {
        console.log('event',event)
        if (type === undefined) {
            alert("Please Select Financial Year!!!");
        } else if (type2 === undefined) {
            alert("Please Select Report Type!!!");
        }
        else{
            Fetchinfo();
        }

    }

    function exportJsonToXLSX(data, sheetName, excelFileName) {
        try {
            var workBook = XLSX.utils.book_new();
            var workSheet = XLSX.utils.json_to_sheet(data, {
                skipHeader: false,
            });
            XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
            XLSX.writeFile(workBook, excelFileName);
            return true;
        }
        catch
        {
            return false;
        }
    }

    function exportToExcel() {
        let fileNameChange = "Report.xlsx";
        let sheetName = "sheet";

        let excelExportData = [];

        for (let i = 0; i < extGridData.length; i++) {
            let data = {};
            for (let key in extGridData[i]) {
                for (let j = 0; j < datacolumnnames.length; j++) {
                    if (key === datacolumnnames[j]["field"]) {
                        data[datacolumnnames[j]["headerName"]] = extGridData[i][key]
                    }
                }
            }

            excelExportData.push(data);
        };

        exportJsonToXLSX(excelExportData, sheetName, fileNameChange);

    }


    function handleChange(data) {
        setCompanyName(data);
        console.log(data.value);
        setHideResultGrid(true);

    }

    function handleChange1(data) {
        setType(data);
    	const [fromYear, toYear] = data.value.split('-').map(year => year.trim());
    	console.log('fromYear, toYear', fromYear, toYear);
    	setFromyear(fromYear);
    	setToyear(toYear);  
        console.log(data.value);
        setHideResultGrid(true);
    }
    function handleChange2(data) {
        setType2(data);
        console.log(data.value);
        setHideResultGrid(true);
    }


    function onChangeMonth(e){
        setInputMonth(e.target.value);
        console.log(e.target.value);
    }

    
    const timeOperation = (name, operation) => {
        aggCallCount = 0;
        compareCallCount = 0;
        filterCallCount = 0;
        var start = new Date().getTime();
        operation();
        var end = new Date().getTime();
        console.log(
        name +
            ' finished in ' +
            (end - start) +
            'ms, aggCallCount = ' +
            aggCallCount +
            ', compareCallCount = ' +
            compareCallCount +
            ', filterCallCount = ' +
            filterCallCount
        );
    };


    	
	function searchForm(){
        setLoaderOpen(true);
        console.log(inputMonth);
        let payload = {
            "tenants_id": userCredentials["tenants_id"],
            "groups_id": userCredentials["groups_id"],
            "entities_id": userCredentials["entities_id"],
            "m_processing_layer_id": userCredentials["m_processing_layer_id"],
            "m_processing_sub_layer_id": userCredentials["m_processing_sub_layer_id"],
            "processing_layer_id": userCredentials["processing_layer_id"],
            "is_active": "yes",
            "month" : inputMonth,
        }
        var getFileProcess;
        if (userCredentials["tenants_id"] == 1){
            getFileProcess = getFileProcessFromServer1();
        }else{
            getFileProcess = getFileProcessFromServer2();
        }
        

        axios.post(getFileProcess[1],{params : payload}, getFileProcess[0])
        .then(
            response => {
                console.log("File Process Response!!!", response)
                let data = response["data"];
                console.log("response", data)
                if (data["Status"] === "Success")
                {
                    alert("File Processed Successfully!!!");
                    setLoaderOpen(false);
                }else{
                    setLoaderOpen(false);
                }
            }
        ).catch(
            error => {
                console.log("Error in File Process List!!!", error);
                setLoaderOpen(false);
            }
        );
    }

    return (
        <>
         <div className="report-cardBox">
             <div className="form-groups ">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`} style={{ paddingBottom :'5px' }}>Financial Year</label> <br />
              <div className="reconsummary">
                <Select
                  clearable
                  options={columnnames}
                  selection
                  size='mini'
                  onChange={handleChange1}
                  value={type}
                  style={{ backgroundColor: 'white' }}

                />
              </div>
              </div>
             <div className="form-groups ">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`} style={{ paddingBottom :'5px' }}>Report Type</label> <br />
              <div className="reconsummary">
                <Select
                  clearable
                  options={columnnames1}
                  selection
                  size='mini'
                  onChange={handleChange2}
                  value={type2}
                  style={{ backgroundColor: 'white' }}

                />
              </div>

            </div>
              <button className="btn" style={{ height: "35px", width: "92px", marginTop: "48px", backgroundColor: "#000055", color: "#ffffff" }} onClick={(e) => { searchClick(e) }}>Search</button>
            </div>
            <div className="report" hidden={hideResultGrid}>
                <div>
                    <img src={excelIcon} alt="No Images" style={{ width: '40px', height: '37px' }} className="excel-icon-class" onClick={() => { exportToExcel() }} title="Export" />                
                </div>
                <div className="ag-theme-balham report-layer" style={{width:'100%', heidght:'100%'}}>
                    <AgGridReact
                        columnDefs={datacolumnnames}
                        rowData={extGridData}
                         animateRows={true}
              //rowSelection={'multiple'}
              pagination={true}
              paginationPageSize={15}
              groupSelectsChildren={true}
              suppressAggAtRootLevel={true}
              //onRowSelected={handleCheckboxChangeInt}
              suppressRowClickSelection={true}
              suppressFieldDotNotation={true}
              enableCellTextSelection= {true}
                        
                    >
                    </AgGridReact>
                </div>
            </div>
          
            <LoaderComponent loaderOpen={loaderOpen} />

        </>
    )
}

export default AlcsReport;










